// inspired by https://github.com/sindresorhus/npm-keyword/blob/master/index.js

import axios from "axios";
import registryUrl from "registry-url";

export interface Options {
    registry?: string;
}

export interface NpmPackage {
    name: string;
    scope: "unscoped" | string;
    version: string;
    description: string;
    keywords: string[];
    date: { ts: number; rel: string };
    links: { npm: string; homepage: string; repository: string; bugs: string };
    author: { name: string; email: string };
    publisher: {
        name: string;
        email: string;
        avatars: { small: string; medium: string; large: string };
        created: { ts: number | null; rel: string };
    };
    maintainers: { name: string; email: string }[];
    keywordsTruncated: boolean;
}

export interface SearchResultObject {
    package: NpmPackage;
    searchScore: number;
    score: {
        final: number;
        detail: {
            quality: number;
            popularity: number;
            maintenance: number;
        };
    };
}

export interface SearchResult {
    total: number;
    objects: SearchResultObject[];
}

const SIZE = 250;
const urls = {
    search: (keyword: string, offset: number, size: number, registry: string) =>
        `${registry}-/v1/search?text=keywords:${keyword}&size=${size}&from=${offset}`,
};

const getNpmPackagesByKeyword = async (
    keyword: string,
    { registry = registryUrl() }: Options = { registry: registryUrl() },
): Promise<NpmPackage[]> => {
    keyword = encodeURIComponent(keyword).replace("%2C", "+");

    const packages = [] as NpmPackage[];
    const { total } = await search(keyword, 0, 1, registry);
    let fetched = 0;

    while (fetched < total) {
        const { objects } = await search(keyword, fetched, SIZE, registry);
        packages.push(...objects.map(obj => obj.package));
        fetched += SIZE;
    }

    return packages;
};

const search = async (
    keyword: string,
    offset: number,
    size: number,
    registry: string,
): Promise<SearchResult> =>
    (await axios.get(urls.search(keyword, offset, size, registry))).data;

export default getNpmPackagesByKeyword;
